var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4418 29.3059C58.3969 28.1383 58.3969 27.0156 58.3969 25.9377C58.3969 25.0845 57.7232 24.4108 56.87 24.4108C50.2683 24.3659 45.2384 22.4797 41.0618 18.4379C40.478 17.854 39.49 17.854 38.9062 18.4379C34.7296 22.4797 29.6998 24.3659 23.143 24.3659C22.2897 24.3659 21.6161 25.0396 21.6161 25.8928C21.6161 26.9707 21.6161 28.0934 21.5712 29.3059C21.3466 40.3986 21.0322 55.533 39.49 61.9102C39.6696 61.9551 39.8044 62 39.984 62C40.1637 62 40.3433 61.9551 40.478 61.9102C58.9358 55.533 58.6214 40.3986 58.4418 29.3059Z",
    fill: "#E3E2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4418 29.3057C58.3969 28.1381 58.3969 27.0153 58.3969 25.9375L25.644 51.7069C28.2802 55.8903 32.5633 59.5168 39.49 61.9099C39.6697 61.9549 39.8044 61.9998 39.984 61.9998C40.1637 61.9998 40.3433 61.9549 40.478 61.9099C58.9358 55.5328 58.6214 40.3983 58.4418 29.3057Z",
    fill: "#D2D1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2832 34.6502L37.8731 42.0602L34.6846 38.8717C34.1007 38.2878 33.1127 38.2878 32.484 38.8717C31.9002 39.4555 31.9002 40.4435 32.484 41.0722L36.7504 45.3386C37.0648 45.653 37.424 45.7877 37.8282 45.7877C38.2324 45.7877 38.6366 45.653 38.9061 45.3386L47.4388 36.8058C48.0227 36.222 48.0227 35.234 47.4388 34.6053C46.855 34.0214 45.867 34.0214 45.2832 34.6502Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.3afc74156f845c57ee1efcee88929a27.svg";
export { ForwardRef as ReactComponent };